import { Button } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { IncomingEmailsTable } from "@/components/mailboxes";

/** Props Interface */
interface MailboxEmailsModalProps extends ModalProps {
	mailboxId: string;
	label: string;
}

export function MailboxEmailsModal({ isOpen, onClose, mailboxId, label }: MailboxEmailsModalProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={t("mailboxes.emails_of", { label })}
			width="70rem"
		>
			<Modal.Body>
				<IncomingEmailsTable
					mailboxId={mailboxId}
					persistenceKey="mailbox-emails-modal-table"
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button
					onClick={onClose}
					variant="ghost"
				>
					{t("general.close")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
